var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"social"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"social__title"},[_vm._v("\n            Suivez-nous\n        ")]),_c('ul',{staticClass:"social__menu"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }